var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestosHumanos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8172 17.9975C12.738 17.9975 7.84135 24.6875 7.80176 24.6875C7.76218 24.6875 2.90509 21.3146 2.88586 21.2728C2.86664 21.2309 7.78254 14.2591 7.78254 14.1642C7.78254 14.0415 0.454484 11.7091 0.00213491 11.5362C-0.0713718 11.5083 1.77761 5.85603 1.79457 5.83929C1.82849 5.80023 9.95947 8.46175 10.0217 8.46175C10.0443 8.46175 10.0726 8.42827 10.0782 8.38922C10.1008 8.27762 10.1348 0.0977727 10.1743 0.0419756C10.2196 -0.0249808 16.0831 0.00291774 16.1171 0.0252366C16.2019 0.0810336 16.315 8.73516 16.462 8.73516C16.5412 8.73516 24.3046 6.1127 24.3385 6.15175C24.3838 6.20197 26.1423 11.8542 26.1196 11.8765C26.0688 11.9267 18.1922 14.5046 18.1696 14.5994C18.1526 14.6775 22.8514 21.4122 22.8345 21.4569C22.8175 21.5015 18 25 17.9547 25C17.8982 24.9888 12.9224 17.9975 12.8149 17.9975H12.8172Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestosHumanos);
export default __webpack_public_path__ + "static/media/restos-humanos.a6096b49eed073ba64c67225cc6a1224.svg";
export { ForwardRef as ReactComponent };